/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a feature bundle
 * @export
 * @interface CreateFeatureBundleRequest
 */
export interface CreateFeatureBundleRequest {
    /**
     * Bundle ID (stable identifier, e.g. MXDR)
     * @type {string}
     * @memberof CreateFeatureBundleRequest
     */
    bundleId: string;
    /**
     * Display name
     * @type {string}
     * @memberof CreateFeatureBundleRequest
     */
    name: string;
    /**
     * Optional description
     * @type {string}
     * @memberof CreateFeatureBundleRequest
     */
    description?: string;
    /**
     * List of feature_id from feature_catalog
     * @type {Array<string>}
     * @memberof CreateFeatureBundleRequest
     */
    featureIds?: Array<string>;
    /**
     * Sort order for display
     * @type {number}
     * @memberof CreateFeatureBundleRequest
     */
    sortOrder?: number;
    /**
     * Whether the bundle is active
     * @type {boolean}
     * @memberof CreateFeatureBundleRequest
     */
    active?: boolean;
    /**
     * How to update existing grants when bundle definition changes: SYNC_TO_BUNDLE, GRANDFATHER, NO_CHANGE. Default NO_CHANGE.
     * @type {string}
     * @memberof CreateFeatureBundleRequest
     */
    syncPolicy?: string;
    /**
     * When null, platform catalog. When set to a tenant id, only that grantor can grant this bundle (create from platform admin). Phase E / ADR 0004.
     * @type {string}
     * @memberof CreateFeatureBundleRequest
     */
    providerTenantId?: string;
}

/**
 * Check if a given object implements the CreateFeatureBundleRequest interface.
 */
export function instanceOfCreateFeatureBundleRequest(value: object): value is CreateFeatureBundleRequest {
    if (!('bundleId' in value) || value['bundleId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateFeatureBundleRequestFromJSON(json: any): CreateFeatureBundleRequest {
    return CreateFeatureBundleRequestFromJSONTyped(json, false);
}

export function CreateFeatureBundleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFeatureBundleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bundleId': json['bundleId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'featureIds': json['featureIds'] == null ? undefined : json['featureIds'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'active': json['active'] == null ? undefined : json['active'],
        'syncPolicy': json['syncPolicy'] == null ? undefined : json['syncPolicy'],
        'providerTenantId': json['providerTenantId'] == null ? undefined : json['providerTenantId'],
    };
}

export function CreateFeatureBundleRequestToJSON(json: any): CreateFeatureBundleRequest {
    return CreateFeatureBundleRequestToJSONTyped(json, false);
}

export function CreateFeatureBundleRequestToJSONTyped(value?: CreateFeatureBundleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bundleId': value['bundleId'],
        'name': value['name'],
        'description': value['description'],
        'featureIds': value['featureIds'],
        'sortOrder': value['sortOrder'],
        'active': value['active'],
        'syncPolicy': value['syncPolicy'],
        'providerTenantId': value['providerTenantId'],
    };
}

